import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {ChipsAutocompleteModule} from '../../../../../../core/component/chips-autocomplete/chips-autocomplete.module';
import {LovValueChipsAutocompleteComponent} from './lov-value-chips-autocomplete.component';


@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        ChipsAutocompleteModule,
    ],
    declarations: [
        LovValueChipsAutocompleteComponent,
    ],
    exports: [
        LovValueChipsAutocompleteComponent
    ]
})
export class LovValuesChipsAutocompleteModule {}
